@if (formGroup) {
  <form [formGroup]="formGroup">
    @if (prescriptionGenerator) {
      @if (prescriptionGenerator.manualSend) {
        <p>{{ 'prescription_generator_manual_send_text' | locale }}</p>
      }
      @if (!prescriptionGenerator.manualSend) {
        <p>
          {{ 'prescrypto_following_link' | locale }}
          <a class="accent-link" style="font-weight: 500" href="" (click)="onClickPrescriptionGeneratorService($event)">
            {{ prescriptionGenerator.service }}</a
            >.
            @if (prescriptionGenerator.url) {
              <span>{{ 'prescrypto_new_tab' | locale }}</span>
            }
          </p>
          <p>{{ 'prescrypto_complete_call' | locale }}</p>
        }
      }
      @if (!prescriptionGenerator) {
        <app-medicine-form
          [call]="call"
          [resetObservable]="resetSubject.asObservable()"
          (onSelectMedicine)="onSelectMedicine($event)"
          (onChangeQuantity)="checkProlongedTreatment()"
          (validFormChange)="checkIsValidMedicineForm($event)"
          (onSubmitForm)="addMedicinePrescription($event)"
          >
        </app-medicine-form>
        @if (prescriptions.controls?.length > 0) {
          <h2>{{ 'prescription_other_medicines' | locale }}</h2>
          <mat-divider></mat-divider>
          @for (medicineFormGroup of prescriptions?.controls; track medicineFormGroup; let index = $index) {
            <app-item
              [itemText]="medicineFormGroup.get('medicine')?.value?.active"
              [south]="true"
              iconName="capsule"
              color="bg-primary"
              [collapsable]="true"
              [itemDetailTemplate]="prescripted"
              [data]="medicineFormGroup"
              [index]="index"
              [displayTrashButton]="!medicineFormGroup.get('status')?.value"
              (removeEvent)="removeMedicine($event)"
              >
            </app-item>
          }
          <ng-template #prescripted let-open="openCollapsable" let-medicineFormGroup="data" let-index="index">
            @if (open) {
              <div class="collapsable">
                <app-medicine-form
                  [formGroup]="medicineFormGroup"
                  [index]="index"
                  [displaySubmitButton]="false"
                  (onSelectMedicine)="onSelectMedicine($event)"
                  (onChangeQuantity)="checkProlongedTreatment()"
                  >
                </app-medicine-form>
              </div>
            }
          </ng-template>
        }
      }
      <mat-checkbox [formControl]="isPrescription" color="primary">{{ 'is_prescription' | locale }}</mat-checkbox>
      @if (!prescriptionGenerator) {
        <mat-checkbox [formControl]="prolongedTreatment" color="primary">{{
          'prolonged_treatment' | locale
        }}</mat-checkbox>
      }
      @if (!prescriptionGenerator) {
        <mat-checkbox
          [formControl]="sendDuplicates"
          color="primary"
          (click)="doctorChangesSendDuplicates = true"
          >{{ 'is_duplicate' | locale }}</mat-checkbox
          >
        }
        <div class="actions">
          @if (prescriptionGenerator && prescriptionGenerator.manualSend && !prescriptionGeneratorHasPrescriptions) {
            <button
              mat-flat-button
              color="primary"
              (click)="onClickPrescriptionGeneratorService($event)"
              >
              {{ 'prescription_generator_generate_button' | locale }} {{ prescriptionGenerator.service }}
            </button>
          }
          @if (
            !prescriptionGenerator || (prescriptionGenerator && (prescriptionGeneratorHasPrescriptions || !prescriptionGenerator.manualSend))
            ) {
            <button
              type="submit"
              mat-flat-button
              color="primary"
              (click)="next()"
      [disabled]="
        !prescriptionGenerator &&
        (!prescriptions.valid ||
          (prescriptions?.length == 0 && !isMedicineFormValid) ||
          (prescriptions?.length > 0 && !isMedicineFormValid && hasSomeFilledFields) ||
          (!isMedicineFormValid && prescriptions?.length === call.prescriptions?.length))
      "
              >
              {{ (prescriptionGenerator && !prescriptionGenerator.manualSend ? 'continue' : 'prescription_send') | locale }}
              <mat-icon svgIcon="arrow-right" class="east"></mat-icon>
            </button>
          }
          @if (!prescriptionGenerator || (prescriptionGenerator && !prescriptionGeneratorHasPrescriptions)) {
            <button
              mat-flat-button
              color="primary"
              (click)="skipStep()"
              >
              {{ 'prescription_skip' | locale }}
              <mat-icon svgIcon="arrow-right" class="east"></mat-icon>
            </button>
          }
        </div>
      </form>
    }
